import React from 'react';
import cn from 'classnames';

import { Icon, Portal } from 'components';
import SettingsMobileOverlay from '../../SettingsMobileOverlay';
import useSettingsButtonMobile from './useSettingsButtonMobile';
import SettingsIcon from 'assets/svg/settings.svg';
import './settingsButtonMobile.scss';

const SettingsButtonMobile = () => {
    const {
        isOpened,
        toggleModal,
        container,
        modalContainer,
    } = useSettingsButtonMobile();

    return (
        <div styleName="container" ref={container}>
            <Icon
                styleName={cn('icon', {
                    'is-open': isOpened,
                })}
                glyph={SettingsIcon}
                onClick={toggleModal}
            />
            {isOpened && (
                <Portal>
                    <SettingsMobileOverlay container={modalContainer} />
                </Portal>
            )}
        </div>
    );
};

export default React.memo(SettingsButtonMobile);
